export default __webpack_public_path__ + "static/media/Blue_Button_Shop.945dfc31.jpg";